var Track = function (action, data) {
    try {
        gtag('event', action, data);
    } catch (err) {
        console.log("err event:", err.message);
    }
};

var App = function ($) {

    var cookie = {
        set: function (name, value) {
            document.cookie = name + '=' + value + ';path=/';
        },
        get: function (name) {
            var cookie, cookies_object = {},
                cookies_array = document.cookie.split(';').map(function (x) {
                    return x.replace(/ /g, '').split("=");
                });
            for (var i in cookies_array) {
                cookie = cookies_array[i];
                cookies_object[cookie[0]] = cookie[1];
            }
            return cookies_object[name];
        },
        delete: function (name) {
            cookie.set(name, '');
        },
        clear: function () {
            App.cookie.set('clear_cache', true);
        }
    };

    var init = function () {
        var selectField = document.querySelector('select[name="region"]');
        if (selectField) {
          selectField.options[0].text = 'Seleccione una región'; // Cambia el texto de la primera opción
          selectField.options[0].disabled = true; // Deshabilita la primera opción
        }

        if ($('#desktop_stand').length) {
            $('#db-ws').attr('href', $('#whatsapp-button').attr('href'));
            $('.modal.info_contacto .modal-body').html($('#info_contacto').clone());
            $('.modal.descripcion .modal-body').html($('#descripcion').clone());
            $('.modal.video .modal-body').html($('#video .fusion-video.fusion-youtube').clone());
            $('.modal.galeria .modal-body').html($('#galeria .fusion-gallery').clone());
            $('.modal.documentos .modal-body').html($('#documentos .fusion-content-boxes').clone());
            $('a[data-dismiss="modal"]').html('Cerrar');
            $('#menu-principal a').on('click', function (e) {
                e.preventDefault();
            });
        }
        if ($('.modal').length) {
            $('.modal').on('show.bs.modal', function () {
                setTimeout(function () {
                    $(window).trigger('fusion-resize-horizontal');
                }, 500);
            })

            var dismiss = $('a[data-dismiss="modal"], button[data-dismiss="modal"]');
            
            if (dismiss.length) {
                dismiss.each(function (e) {
                    $(this).html($(this).html().replace('Close', 'Cerrar'));
                });
            }
        }

        // var modal_subamos = $('.modal.subamos');
        // if (modal_subamos.length){
        //     modal_subamos.find('a[data-dismiss="modal"], button[data-dismiss="modal"], .close').on('click', function () {
        //         App.cookie.set('subamos', true);
        //     });
        //     if (!App.cookie.get('subamos')) {
        //         modal_subamos.modal('show');
        //     }
        // }

        $('#enviar-registro').on('click', function (e) {
            location.href = "#participa";
            history.replaceState(null, null, url);
        });

        $('#menu-item-4110').attr('target', '_blank');
        $('#menu-item-6692').attr('target', '_blank');
        $('a.quiero-donar, #menu-item-6692').on('click', function (e) {
            Track('donar', {});
        })


        $('.ga-track').on('click', function (e) {
            var t = $(this);
            Track(t.data('action'), {
                'event_category': t.data('category'),
                'event_label': t.data('label')
            });
        });

        if ($('.page-id-8160, .page-id-8431').length) {
            $(window).resize(function () {
                $('iframe.online-data').css('height', $('iframe.online-data').width() * 745 / 1324 + 'px');
            });
        }

        var wpcf7Elm = document.querySelector('.wpcf7');

        wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
            Track('formSubmission', {
                'event_category': 'Petition Signup'
            });
            fbq('track', 'CompleteRegistration');

            $('.modal.gracias').modal('show');
        }, false);

        function copyToClipboard(elem) {
            // create hidden text element, if it doesn't already exist
            var targetId = "_hiddenCopyText_";
            var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
            var origSelectionStart, origSelectionEnd;
            if (isInput) {
                // can just use the original source element for the selection and copy
                target = elem;
                origSelectionStart = elem.selectionStart;
                origSelectionEnd = elem.selectionEnd;
            } else {
                // must use a temporary form element for the selection and copy
                target = document.getElementById(targetId);
                if (!target) {
                    var target = document.createElement("textarea");
                    target.style.position = "absolute";
                    target.style.left = "-9999px";
                    target.style.top = "0";
                    target.id = targetId;
                    document.body.appendChild(target);
                }
                target.textContent = elem.textContent;
            }
            // select the content
            var currentFocus = document.activeElement;
            target.focus();
            target.setSelectionRange(0, target.value.length);

            // copy the selection
            var succeed;
            try {
                succeed = document.execCommand("copy");
            } catch (e) {
                succeed = false;
            }
            // restore original focus
            if (currentFocus && typeof currentFocus.focus === "function") {
                currentFocus.focus();
            }

            if (isInput) {
                // restore prior selection
                elem.setSelectionRange(origSelectionStart, origSelectionEnd);
            } else {
                // clear temporary content
                target.textContent = "";
            }
            return succeed;
        }

        $('#copy_rrss_txt').on('click', function () {
            copyToClipboard(document.getElementById("txt_rrss"));
        })

        var text = encodeURIComponent("Súmate y ACTÚA por los glaciares, el agua, el aire y la biodiversidad de la RM 📢 Subamos la voz y #BajemosLosBronces! Firma la petición y dile NO al avance de Los Bronces Integrado ❌");
        $('a[data-title="Facebook"]').attr("href","https://www.facebook.com/sharer.php?u=https%3A%2F%2Fbajemoslosbronces.cl%2F&t="+text)
        $('a[title="X"]').attr("href","https://twitter.com/intent/tweet?text="+text+"&url=https%3A%2F%2Fbajemoslosbronces.cl%2F")


    };

    return {
        init: init,
        cookie: cookie
    };
}(jQuery);

jQuery(function () {
    App.init();
});